import { render, staticRenderFns } from "./sponser-added.vue?vue&type=template&id=5729b4f8&scoped=true&"
import script from "./sponser-added.vue?vue&type=script&lang=js&"
export * from "./sponser-added.vue?vue&type=script&lang=js&"
import style0 from "./sponser-added.vue?vue&type=style&index=0&id=5729b4f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5729b4f8",
  null
  
)

component.options.__file = "sponser-added.vue"
export default component.exports